import { InjectionToken } from '@angular/core';

import { AuthAdapter } from './auth-adapter.interface';

export const AUTH_ADAPTER = new InjectionToken<AuthAdapter>('Auth Adapter');
